class StepManager {
    constructor(containerSelector) {
        this.containerSelector = containerSelector;
        this.selectedSteps = {};
        this.currentStep = null;
        this.nextStep = null;
        this.init();
    }

    init() {
        this.container = document.querySelector(this.containerSelector);
        this.steps = Array.from(this.container.querySelectorAll('.configurator'));
        this.steps.forEach((step, index) => {
            const stepKey = step.dataset.variantPickerGroup;
            this.selectedSteps[stepKey] = index === 0;
            this.currentStep = index === 0 ? stepKey : this.currentStep;
        });
        this.initEventListeners();

        this.scrollToInit();
        this.updateStepLocking();
    }

    scrollToInit() {
        setTimeout(() => {
            this.container.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 1000);
    }

    initEventListeners() {
        this.steps.forEach((step) => {
            const stepKey = step.dataset.variantPickerGroup;
            step.addEventListener('bundle_product:change', (event) => this.handleStepChange(event, stepKey))
            step.addEventListener('bundle_quantity:change', (event) => this.handleStepChange(event, stepKey))
            step.addEventListener('input', (event) => this.scrollToImage(event, stepKey));
        });
    }

    closeVariants(event, stepKey) {
        const currentStep = this.container.querySelector(`[data-variant-picker-group="${stepKey}"]`);
        const variants_container = currentStep.querySelector('.values-images-variants-container')
        if (variants_container) {
            variants_container.classList.remove('selected');
            const siblings = variants_container.querySelectorAll('[data-context-container]');
            siblings.forEach(sibling => {
                sibling.classList.remove('selected');
                const videos = sibling.querySelectorAll("video");
                videos.forEach(video => {
                    video.pause();
                });
                const inputs = sibling.querySelectorAll('input');
                inputs.forEach(input => {
                    if (input.type === 'checkbox' || input.type === 'radio') {
                        input.checked = false;
                    }
                });
            });
        }
    }

    openVariants(event, stepKey) {
        const target = event.target;
        const currentStep = this.container.querySelector(`[data-variant-picker-group="${stepKey}"]`);
        const productId = target.getAttribute('data-product-id')
        const variants_container = currentStep.querySelector('.values-images-variants-container')
        if (variants_container) {
            variants_container.classList.add('selected');
            const variantsProduct = variants_container.querySelector(`[data-context-container="${productId}"]`);
            if (variantsProduct) {
                const siblings = variantsProduct.parentElement.querySelectorAll('[data-context-container]');
                siblings.forEach(sibling => {
                    sibling.classList.remove('selected');
                    const videos = sibling.querySelectorAll("video");
                    videos.forEach(video => {
                        video.pause();
                    });
                });
                setTimeout(() => {
                    variantsProduct.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 1000);
                variantsProduct.classList.add('selected');
                const videos = variantsProduct.querySelectorAll("video");
                videos.forEach(video => {
                    video.load();
                });
            }
        }
    }

    scrollToImage(event, stepKey) {
        const target = event.target;
        const currentStep = this.container.querySelector(`[data-variant-picker-group="${stepKey}"]`);
        const context_select_id = target.getAttribute('data-context-value')
        const context_select = currentStep.querySelector(`label[data-context="${context_select_id}"]`);

        if (context_select) {
            const siblings = context_select.parentElement.querySelectorAll('label[data-context]');
            siblings.forEach(sibling => {
                sibling.classList.remove('selected');
            });
            context_select.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            context_select.classList.add('selected');
        }
    }

    handleStepClick(event, stepKey) {
        const type_step = target.getAttribute('data-option-step') == "true"
        if (type_step) {
            this.handleStepChange(event, stepKey)
            setTimeout(() => {
                this.scrollToNextStep(this.nextStep);
            }, 1000);
        }
    }

    handleStepChange(event, stepKey) {
        const target = event.target;
        const type_step = target.getAttribute('data-option-step') == "true"

        if (type_step) {

            if (target.value == "none") {
                this.closeVariants(event, stepKey)
            }

            this.selectedSteps[stepKey] = true;
            const nextStep = this.getNextStep(stepKey);

            if (nextStep && !this.selectedSteps[nextStep]) {
                this.selectedSteps[nextStep] = true;
                this.currentStep = stepKey;
                this.nextStep = nextStep;
            }

            if (nextStep) {
                this.updateStepLocking();
                setTimeout(() => {
                    this.scrollToNextStep(this.nextStep);
                }, 1000);
            }
        } else {

            if (target.value != "none") {
                this.openVariants(event, stepKey)
            }
        }
    }

    uncheckInputsOfNextStep(nextStepKey) {
        const nextStep = this.container.querySelector(`[data-variant-picker-group="${nextStepKey}"]`);
        if (nextStep) {
            const labels = nextStep.querySelectorAll('label');
            labels.forEach(label => {
                label.style.color = 'rgb(var(--text-color) / .65)';
                label.style.borderColor = 'rgb(var(--border-color))';
            });

        }
    }

    scrollToNextStep(nextStepKey) {
        const nextStep = this.container.querySelector(`[data-variant-picker-group="${nextStepKey}"]`);
        if (nextStep) {
            setTimeout(() => {
                nextStep.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                setTimeout(() => {
                    this.openImages(this.nextStep);
                }, 500);

            }, 1000);
        }
    }

    openImages(nextStepKey) {
        const nextStep = this.container.querySelector(`[data-variant-picker-group="${nextStepKey}"]`);
        if (nextStep) {
            const option = nextStep.querySelector('input[data-option-position]:checked')
            if (option) {
                const optionValue = option.value

                const item = nextStep.querySelector(`.block-swatch-image[data-option-value="${optionValue}"]`);
                if (item) {
                    const siblings = item.parentElement.querySelectorAll('label');
                    siblings.forEach(sibling => {
                        sibling.classList.remove('selected');
                    });
                    item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                    item.classList.add('selected');
                }
            }
        }
    }

    handleDomUpdate() {
        this.container = document.querySelector(this.containerSelector);
        this.steps = Array.from(this.container.querySelectorAll('.configurator'));
        this.initEventListeners();
        this.updateStepLocking();
    }

    updateStepLocking() {
        this.steps.forEach((step) => {
            const stepKey = step.dataset.variantPickerGroup;


            if (this.selectedSteps[stepKey]) {
                step.classList.add('selected');

                const inputs = step.querySelectorAll('input');
                const buttons = step.querySelectorAll('button');

                inputs.forEach(input => {
                    input.disabled = false;
                });

                buttons.forEach(button => {
                    button.disabled = false;
                });

            } else {
                step.classList.remove('selected');


                const inputs = step.querySelectorAll('input');
                const buttons = step.querySelectorAll('button');

                inputs.forEach(input => {
                    input.disabled = true;
                    if (input.type === 'checkbox' || input.type === 'radio') {
                        input.checked = false;
                    }
                });

                buttons.forEach(button => {
                    button.disabled = true;
                });
            }
        });
    }


    getNextStep(currentStepKey) {
        const stepKeys = this.steps.map(step => step.dataset.variantPickerGroup);
        const currentIndex = stepKeys.indexOf(currentStepKey);
        return currentIndex >= 0 && currentIndex < stepKeys.length - 1 ? stepKeys[currentIndex + 1] : null;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.bundle-pack-page')) {
        const indicateurEl = document.querySelector('.bundle-pack-page')
        const containerEl = indicateurEl.closest('main')
        const id = containerEl.getAttribute('id');

        const stepManager = new StepManager(`#${id}`);
        window.__biocementoBundleStepManager = stepManager;

        const supportFieldset = document.querySelector('[data-variant-picker-group="support-group"]');
        const mortierFieldset = document.querySelector('[data-variant-picker-group="mortier-group"]');

        function syncMortierFromSupport() {
            if (!supportFieldset || !mortierFieldset) return;
            const checked = supportFieldset.querySelector('input[type="radio"]:checked');
            const needsMortier = checked && checked.getAttribute('data-support-needs-mortier') === 'true';
            const mortierSection = mortierFieldset.closest('.shopify-section');
            const noneInput = mortierFieldset.querySelector('input[type="radio"][value="none"]');
            const productInputs = Array.from(mortierFieldset.querySelectorAll('input[type="radio"]')).filter(
                (el) => el.value !== 'none'
            );

            if (needsMortier) {
                mortierSection?.classList.remove('hidden');
                mortierFieldset.querySelectorAll('input[type="radio"]').forEach((i) => {
                    i.disabled = false;
                });
                if (noneInput) noneInput.checked = false;
                if (productInputs.length === 1) {
                    productInputs[0].checked = true;
                    productInputs[0].dispatchEvent(new Event('change', { bubbles: true }));
                }
            } else {
                mortierSection?.classList.add('hidden');
                productInputs.forEach((i) => {
                    i.checked = false;
                    i.disabled = true;
                });
                if (noneInput) {
                    noneInput.disabled = false;
                    noneInput.checked = true;
                    noneInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            const rangeSlider = document.querySelector('.bundle-pack-page')?.closest('main')?.querySelector('#range-slider');
            rangeSlider?.dispatchEvent(new Event('bundle_quantity:change', { bubbles: true }));

            window.__biocementoBundleStepManager?.updateStepLocking?.();
        }

        supportFieldset?.addEventListener('change', syncMortierFromSupport);
        syncMortierFromSupport();
    }
});
